/**
 * Page Layout Component - Reusable layout for all internal pages
 * Provides consistent dark background, container, breadcrumbs, and spacing using theme tokens
 */

import React from 'react';
import Breadcrumbs from './Breadcrumbs';
import { useTheme } from '../contexts/ThemeContext';
import styles from './PageLayout.module.css';

const PageLayout = ({
  children,
  className = '',
  style = {},
  containerStyle = {},
  maxWidth = '1400px', // Container max width
  ...props
}) => {
  const { theme } = useTheme();

  const customContainerStyle = {
    maxWidth,
    ...containerStyle
  };

  return (
    <div
      className={`page-layout ${styles.pageLayout} ${className}`}
      style={style}
      {...props}
    >
      <div
        className={`container ${styles.container}`}
        style={customContainerStyle}
      >
        {/* Page Content */}
        {children}
      </div>
    </div>
  );
};

export default PageLayout;
